import React from 'react';
import { Modal, Input, Form, Select, Icon, DatePicker, Tabs, Button, Tag } from 'antd';
import moment from 'moment';
import './styles.css';
import { message } from 'antd';

import { FORMAT_NUMBER, FORMAT_3DECIMALS } from '../../../common/types/regularExpresionType';

import DetalleServicioModal from './FormModal/DetalleServicioModal';
import DetalleReferenciaModal from './FormModal/DetalleReferenciaModal';
import TotalDetalle from './FormModal/TotalDetalleModal';

import auth from '../../../common/utility/auth';
import global from '../../../common/utility/global';

import { REGISTRADO } from '../../../common/types/ordenServicioEstadoType';
import { ORDEN_SERVICIO } from '../../../common/types/tipoComprobanteType';

import {
    VENTA_PRECIO_UNITARIO_INCLUYE_IGV,
    IMPUESTO_SELECTIVO_CONSUMO_VENTA
} from '../../../common/types/parametroType';

const InputGroup = Input.Group;
const { Search } = Input;
const { Option } = Select;
const { TabPane } = Tabs;

class FormModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }

    findDaysAndDates = (property, value) => {
        if (property === 'diasVencimiento') {
            const fecha = moment(this.props.form.getFieldValue('fechaStr'), 'DD/MM/YYYY');
            const diasVencimiento = parseInt(value);
            this.props.form.setFieldsValue({ fechaVencimientoStr: fecha.add('days', diasVencimiento) });
        }

        if (property === 'fechaVencimientoStr') {
            const fecha = moment(this.props.form.getFieldValue('fechaStr'), 'DD/MM/YYYY');
            const fechaVencimiento = moment(value, 'DD/MM/YYYY');
            this.props.form.setFieldsValue({ diasVencimiento: fechaVencimiento.diff(fecha, 'days').toString() });
        }

        if (property === 'fechaStr') {
            const fechaVencimiento = moment(this.props.form.getFieldValue('fechaVencimientoStr'), 'DD/MM/YYYY');
            const fecha = moment(value, 'DD/MM/YYYY');
            const mf = fecha.format('YYYY/MM/DD');
            console.log('cambio 2');

            this.props.form.setFieldsValue({ diasVencimiento: fechaVencimiento.diff(fecha, 'days').toString(), minFechaStr: mf });
        }
    };

    handleCompleteDecimals = (property, value) => {
        if (value === '' || isNaN(parseFloat(value).toFixed(3)))
            this.props.form.setFieldsValue({ [property]: '0.000' });
        else
            this.props.form.setFieldsValue({ [property]: parseFloat(value).toFixed(3) });
    }

    handleRemoverProducto = (identifier) => {
        var arrDetalle = this.props.form.getFieldValue("arrDetalle");
        var arrDetalleFilter = arrDetalle.filter(m => { return m.identifier !== identifier });

        var _sumaSubTotal = 0;
        arrDetalleFilter.forEach(item => {
            _sumaSubTotal = _sumaSubTotal + item.subTotal;
        });

        var sumaTotal = this.fetchFieldValueSum(identifier, "arrTotal", 0);
        var sumaSubTotal = _sumaSubTotal;
        var sumaIgv = sumaTotal - sumaSubTotal;


        this.props.form.setFieldsValue({

            sumaTotal: sumaTotal,
            sumaSubTotal: sumaSubTotal,
            sumaIgv: sumaIgv,

            arrDetalle: arrDetalleFilter
        });

        this.props.onRemoverProducto(identifier);
    }

    handleCancel = () => {
        this.props.onClose();
        this.props.form.resetFields();
    };

    handleOk = (e) => {
        e.preventDefault();
        this.props.form.validateFieldsAndScroll((err, values) => {
            console.log(values);
            if (!err) {
                var porcentajeIGV = 18;

                const form = {
                    "id": values.id,
                    "idMoneda": values.idMoneda.key,
                    "idProveedor": values.idProveedor.key,
                    "idProyecto": values.idProyecto === undefined ? 0 : values.idProyecto.key,
                    "idEstablecimiento": values.idEstablecimiento.key,
                    "idOrdenServicioEstado": REGISTRADO,
                    "fechaStr": values.fechaStr.format('DD/MM/YYYY'),
                    "tipoCambio": parseFloat(values.tipoCambio),
                    "idTipoComprobante": ORDEN_SERVICIO.ID,
                    "serie": values.serie,
                    "idEstablecimientoProveedor": values.idEstablecimientoProveedor.key,
                    "idEmpleado": values.idEmpleado == undefined ? 0 : values.idEmpleado.key,

                    "documento": values.documento,
                    "diasVencimiento": parseInt(values.diasVencimiento),
                    "fechaVencimientoStr": values.fechaVencimientoStr.format('DD/MM/YYYY'),
                    "porcentajeIGV": porcentajeIGV,
                    "subTotal": values.sumaSubTotal,
                    "igv": values.sumaIgv,
                    "total": values.sumaTotal,
                    "observacion": values.observacion,
                    "observacionRechazado": null,
                    "ordenServicioDetalles": [],
                    "ordenServicioReferencias": this.fetchReferencias(values),
                    "condicion": values.condicion,
                    "plazo": values.plazo,
                }


                if (values.arrDetalle.length <= 0) {
                    message.warning('Debe de ingresar como mínimo 1 servicio.');
                    return;
                }
                if (values.sumaTotal === 0) {
                    message.warning('Por favor ingrese lo montos de forma correcta.');
                    return;
                }

                //Detalles----->
                var count_detalles = values.arrDetalle.length;
                for (var i = 0; i < count_detalles; i++) {
                    var det = values.arrDetalle[i];

                    const itemDet = {
                        "id": 0,
                        "idOrdenServicio": null,
                        "idProducto": parseInt(det.idProducto),
                        "nombre": det.nombre,
                        "flagAfecto": det.flagAfecto,
                        "flagExonerado": det.flagExonerado == undefined ? false : det.flagExonerado,
                        "flagGratuito": det.flagGratuito == undefined ? false : det.flagGratuito,
                        "cantidad": det.cantidad,
                        "precioUnitario": det.precioUnitario,
                        "subTotal": det.subTotal,
                        "igv": det.igv,
                        "total": det.total,
                        "idImpuesto": det.idImpuesto,
                        "precioUnitarioSinIGV": det.precioUnitarioSinIGV

                    }

                    form.ordenServicioDetalles.push(itemDet);
                }

                this.props.onSave(form, this.props.form);
            }
        });
    };


    fetchReferencias = (values) => {
        var result = [];

        if (values.idTipoComprobante === undefined)
            return result;

        var keys = [];
        var obj = Object.assign({}, values.idTipoComprobante);

        for (var [key] of Object.entries(obj)) {
            keys.push(key);
        }
        keys.forEach((key) => {
            result.push({
                idTipoComprobante: values.idTipoComprobante[key].key,
                serie: values.series[key],
                documento: values.documentos[key],
                idReferencia: values.arrIdReferencia[key],
                idReferenciaOrigen: values.arrIdReferenciaOrigen[key],
                flagInterno: values.arrFlagInterno[key],
            });
        });

        return result;
    };


    fetchNewValue = (value, numberDecimals) => {
        if (numberDecimals === 2)
            return value === '' || isNaN(parseFloat(value).toFixed(2)) ? 0 : parseFloat(value);
        if (numberDecimals === 3)
            return value === '' || isNaN(parseFloat(value).toFixed(3)) ? 0 : parseFloat(value);
        if (numberDecimals === 5)
            return value === '' || isNaN(parseFloat(value).toFixed(5)) ? 0 : parseFloat(value);
        if (numberDecimals === 0)
            return value === '' || isNaN(parseFloat(value).toFixed(0)) ? 0 : parseFloat(value);

        return 0;
    };

    fetchFieldValue = (identifier, property) => {
        var result = parseFloat(this.props.form.getFieldValue(`${property}[${identifier}]`));
        return result;
    };

    fetchFieldValueSum = (identifier, property, paramValue) => {
        var suma = 0;
        var obj = Object.assign({}, this.props.form.getFieldValue(property));

        for (var [key, value] of Object.entries(obj)) {
            suma = suma + (key === identifier ? paramValue : parseFloat(value));
        }

        return suma;
    };

    fetchSumaTotalAfecto = (
        identifier,
        codex,
        total
    ) => {
        let suma = 0;

        const arrTotal = this.props.form.getFieldValue("arrTotal");
        const arrImpuesto = this.props.form.getFieldValue("arridImpuesto");

        for (const [key, value] of Object.entries(arrTotal)) {

            // 👉 obtenemos el id del impuesto
            const impuestoKey = arrImpuesto?.[key]?.key;

            const selectedImpuesto = this.props.formValues.tipoAfectacion.find(
                x => x.id === impuestoKey
            );

            const codigo = identifier === key ? codex : selectedImpuesto?.codigoSunat;

            // ✅ solo sumar si es 10 o 17
            var esGravado = ["10", "17"].includes(codigo);

            if (esGravado) {
                suma +=
                    identifier === key
                        ? Number(total.toFixed(2))
                        : parseFloat(value);
            }
        }

        return suma;
    };


    fetchSumaTotalInafecto = (
        identifier,
        codex,
        total
    ) => {
        let suma = 0;

        const arrTotal = this.props.form.getFieldValue("arrTotal");
        const arrImpuesto = this.props.form.getFieldValue("arridImpuesto");

        for (const [key, value] of Object.entries(arrTotal)) {

            // 👉 obtenemos el id del impuesto
            const impuestoKey = arrImpuesto?.[key]?.key;

            const selectedImpuesto = this.props.formValues.tipoAfectacion.find(
                x => x.id === impuestoKey
            );

            const codigo = identifier === key ? codex : selectedImpuesto?.codigoSunat;

            // ✅ solo sumar si es 30
            const esInafecto = ["30"].includes(codigo);


            if (esInafecto) {
                suma +=
                    identifier === key
                        ? Number(total.toFixed(2))
                        : parseFloat(value);
            }
        }

        return suma;
    };


    fetchSumaTotalExonerado = (
        identifier,
        codex,
        total
    ) => {
        let suma = 0;

        const arrTotal = this.props.form.getFieldValue("arrTotal");
        const arrImpuesto = this.props.form.getFieldValue("arridImpuesto");

        for (const [key, value] of Object.entries(arrTotal)) {

            // 👉 obtenemos el id del impuesto
            const impuestoKey = arrImpuesto?.[key]?.key;

            const selectedImpuesto = this.props.formValues.tipoAfectacion.find(
                x => x.id === impuestoKey
            );

            const codigo = identifier === key ? codex : selectedImpuesto?.codigoSunat;

            // ✅ solo sumar si es 20
            const esExonerado = ["20"].includes(codigo);

            if (esExonerado) {
                suma +=
                    identifier === key
                        ? Number(total.toFixed(2))
                        : parseFloat(value);
            }
        }

        return suma;
    };


    fetchSumaTotalGratuito = (
        identifier,
        codex,
        total
    ) => {
        let suma = 0;

        const arrTotal = this.props.form.getFieldValue("arrTotal");
        const arrImpuesto = this.props.form.getFieldValue("arridImpuesto");

        for (const [key, value] of Object.entries(arrTotal)) {

            // 👉 obtenemos el id del impuesto
            const impuestoKey = arrImpuesto?.[key]?.key;

            const selectedImpuesto = this.props.formValues.tipoAfectacion.find(
                x => x.id === impuestoKey
            );

            const codigo = identifier === key ? codex : selectedImpuesto?.codigoSunat;

            // ✅ solo sumar si es 20
            const esGratuito = !["10", "20", "30", "40", "17"].includes(codigo);

            if (esGratuito) {
                suma +=
                    identifier === key
                        ? Number(total.toFixed(2))
                        : parseFloat(value);
            }
        }

        return suma;
    };

    fetchSumaTotalExportacion = (
        identifier,
        codex,
        total
    ) => {
        let suma = 0;

        const arrTotal = this.props.form.getFieldValue("arrTotal");
        const arrImpuesto = this.props.form.getFieldValue("arridImpuesto");

        for (const [key, value] of Object.entries(arrTotal)) {

            // 👉 obtenemos el id del impuesto
            const impuestoKey = arrImpuesto?.[key]?.key;

            const selectedImpuesto = this.props.formValues.tipoAfectacion.find(
                x => x.id === impuestoKey
            );

            const codigo = identifier === key ? codex : selectedImpuesto?.codigoSunat;

            // ✅ solo sumar si es 40
            const esGratuito = ["40"].includes(codigo);

            if (esGratuito) {
                suma +=
                    identifier === key
                        ? Number(total.toFixed(2))
                        : parseFloat(value);
            }
        }

        return suma;
    };

    handleCalculateDetail = (identifier, property, value, numberDecimals, row) => {
        debugger
        var newValue = this.fetchNewValue(value, numberDecimals);
        var params = auth.user().parametros;
        var centaje = 0;

        /********* Datos de parametro ******/
        var porcentajeIGV = 18;
        var porcentajeISC = parseFloat(params.filter(m => m.abreviatura === IMPUESTO_SELECTIVO_CONSUMO_VENTA)[0].valor);
        var flagPrecioIncluyeIGV = false;// params.filter(m => m.abreviatura === VENTA_PRECIO_UNITARIO_INCLUYE_IGV)[0].valor === "1" ? true : false;
        centaje = (1.18);
        var precioNuevo = property === "arrPrecio" ? newValue : this.fetchFieldValue(identifier, "arrPrecio");

        /*********** Datos por fila ********/
        var flagAfecto = false;
        var flagExonerado = false;
        var flagGratuito = false;
        var flagISC = false;

        var flagChangeTotal = false;

        var getImpuesto =
            property === "arridImpuesto"
                ? value
                : this.props.form.getFieldValue(`arridImpuesto[${row.identifier}]`).key;


        const selectedImpuesto = this.props.formValues.tipoAfectacion.find(x => x.id === getImpuesto);

        const DEFAULT_CODIGO = '10';
        const codigo = selectedImpuesto?.codigoSunat ?? DEFAULT_CODIGO;

        switch (true) {

            // Gravado
            case ["10", "17"].includes(codigo):
                flagAfecto = true;
                break;

            // Exonerado
            case codigo === "20":
                flagExonerado = true;
                break;

            // Inafecto
            case codigo === "30":
                break;

            // Exportación
            case codigo === "40":
                break;
        }


        var cantidad = property === "arrCantidad" ? newValue : this.fetchFieldValue(identifier, "arrCantidad");
        var precioUnitario = property === "arrPrecioUnitario" ? newValue : this.fetchFieldValue(identifier, "arrPrecioUnitario");
        var total = property === "arrTotal" ? newValue : this.fetchFieldValue(identifier, "arrTotal");




        if (property === "arrFlagAfecto") {
            precioNuevo = value ? (precioUnitario * centaje) : precioUnitario;

        }
        if (property === "arrFlagExonerado") {
            precioNuevo = precioUnitario;

        }

        if (flagAfecto && !flagExonerado) {

            if (property === "arrPrecio") {
                precioUnitario = (precioNuevo / centaje)

            }

            if (property === "arrPrecioUnitario") {
                precioNuevo = (precioUnitario * centaje)

            }

        } else {

            if (property === "arrPrecio") {
                precioUnitario = precioNuevo
                precioNuevo = precioUnitario
            }

            if (property === "arrPrecioUnitario") {
                precioNuevo = parseFloat(value);
                precioUnitario = precioNuevo
            }
        }


        var totalDetalle = cantidad * precioUnitario;
        var divisorCalculoSubTotal = 1 + porcentajeIGV / 100;

        var precioUnitarioSinIGV = flagPrecioIncluyeIGV
            ? precioUnitario / divisorCalculoSubTotal
            : precioUnitario;

        /*********** Calculo totales ********/
        var subTotal = totalDetalle;
        var igv = parseFloat((flagAfecto ? (subTotal * (porcentajeIGV / 100)) : 0).toFixed(2));
        var total = parseFloat(((subTotal + igv)).toFixed(2));

        /*********** Arr Detalle ********/
        var detalle = {
            identifier,
            flagAfecto,
            precioUnitarioSinIGV,
            precioUnitario: precioNuevo,
            precioNuevo,
            cantidad,
            subTotal: parseFloat(subTotal.toFixed(2)),
            igv,
            total,
            idProducto: row.idProducto,
            idImpuesto: selectedImpuesto?.id ?? 1,
            nombre: row.nombre
        };
        debugger
        var arrDetalle = this.props.form.getFieldValue("arrDetalle");
        var arrDetalleFilter = arrDetalle.filter(m => { return m.identifier !== identifier });
        arrDetalleFilter.push(detalle);

        var _sumaSubTotal = 0;
        arrDetalleFilter.forEach(item => {
            _sumaSubTotal = _sumaSubTotal + item.subTotal;
        });


        var sumaTotalAfecto = this.fetchSumaTotalAfecto(
            row.identifier,
            codigo,
            total
        );
        var sumaTotalInafecto = this.fetchSumaTotalInafecto(
            row.identifier,
            codigo,
            total
        );

        var fetchSumaTotalExonerado = this.fetchSumaTotalExonerado(
            row.identifier,
            codigo,
            total
        );

        var fetchSumaTotalGratuito = this.fetchSumaTotalGratuito(
            row.identifier,
            codigo,
            total
        );

        var sumaTotalExportacion = this.fetchSumaTotalExportacion(
            row.identifier,
            codigo,
            total
        );

        var sumaTotal = parseFloat(this.fetchFieldValueSum(row.identifier, "arrTotal", total).toFixed(2));

        var sumaSubTotal = parseFloat(
            (
                sumaTotalAfecto / divisorCalculoSubTotal +
                (sumaTotalInafecto + fetchSumaTotalExonerado + sumaTotalExportacion)
            ).toFixed(2)
        );

        var sumaIgv = (sumaTotal - fetchSumaTotalGratuito) - sumaSubTotal;
        var sumaTotalDetalle = sumaSubTotal;

        this.props.form.setFieldsValue({
            sumaTotal: sumaTotal,
            sumaSubTotal: sumaSubTotal,
            sumaIgv: sumaIgv,

            arrDetalle: arrDetalleFilter,
            [`arrFlagAfecto[${identifier}]`]: flagAfecto,
            [`arrPrecioUnitario[${identifier}]`]: precioUnitario.toFixed(5),
            [`arrCantidad[${identifier}]`]: cantidad.toFixed(3),
            [`arrPrecio[${identifier}]`]: precioNuevo.toFixed(5),

            [`arrSubTotal[${identifier}]`]: subTotal.toFixed(2),
            [`arrIgv[${identifier}]`]: igv.toFixed(2),
            [`arrTotal[${identifier}]`]: total.toFixed(2)
        });

        this.props.form.setFieldsValue({
            arrDetalle: arrDetalleFilter
        });
    };

    handleChangeNameProduct = (row) => {
        this.props.onChangeNameProduct(row);
    };

    handleSearchAutocompleteProveedor = async (value) => {
        const result = this.props.formValues.proveedores.filter(item => {
            return global.formatSearch(`${item.nombre} - ${item.tipoDocumento}`).match(global.formatSearch(value));
        }).slice(0, 75);
        this.props.form.setFieldsValue({ proveedores: result });
    };

    handleChangeAutocompleteProveedor = async (a, element) => {
        this.props.form.setFieldsValue({
            documentoProveedor: element.props.data.numeroDocumento
        }, () => {
            this.props.onChange("idProveedor", element.props.data.idEntidad, this.props.form)
        });
    };

    render() {

        const { getFieldDecorator, setFieldsValue, getFieldValue } = this.props.form;

        var arrayTemp = [];
        var arrDetalle = this.props.form.getFieldValue("arrDetalle");
        for (var i = 0; i < this.props.formValues.listaComprobanteDetalle.length; i++) {
            var item = this.props.formValues.listaComprobanteDetalle[i];
            var existItem = arrDetalle.filter(m => { return m.identifier === item.identifier })

            var d = {
                identifier: item.identifier,
                flagAfecto: item.flagAfecto,
                idProducto: item.idProducto,
                precioUnitario: existItem.length === 0 ? item.precioUnitario : existItem[0].precioUnitario,
                precioUnitarioSinIGV: existItem.length === 0 ? item.precioUnitarioSinIGV : existItem[0].precioUnitarioSinIGV,
                cantidad: existItem.length === 0 ? item.cantidad : existItem[0].cantidad,
                subTotal: existItem.length === 0 ? item.subTotal : existItem[0].subTotal,
                igv: existItem.length === 0 ? item.igv : existItem[0].igv,
                total: existItem.length === 0 ? item.total : existItem[0].total,
                idImpuesto: item.idImpuesto,
                nombre: item.nombre
            };

            arrayTemp.push(d);
        }

        getFieldDecorator('id', { initialValue: this.props.formValues.id });

        getFieldDecorator('arrDetalle', { initialValue: arrayTemp });
        getFieldDecorator('sumaSubTotal', { initialValue: this.props.formValues.sumaSubTotal });
        getFieldDecorator('sumaIgv', { initialValue: this.props.formValues.sumaIgv });
        getFieldDecorator('sumaTotal', { initialValue: this.props.formValues.sumaTotal });
        getFieldDecorator("proveedores", {
            initialValue: this.props.formValues.proveedores.filter((m) => {
                return m.id === this.props.formValues.idProveedor;
            }),
        });

        return (
            <Modal
                title={(<div> {this.props.formValues.id === 0 ? `Registrar Orden de Servicio` : `Modificar Orden de Servicio`}</div>)}
                visible={this.props.visible}
                style={{ top: 30 }}
                cancelText={"Cancelar"}
                okText={"Guardar"}
                onCancel={this.handleCancel}
                onOk={this.handleOk}
                width="1150px"
            >
                <Form>
                    {getFieldDecorator('id', { initialValue: this.props.formValues.id })(
                        <input type="hidden" />
                    )}

                    {getFieldDecorator('minFechaStr', { initialValue: this.props.formValues.minFechaStr })(
                        <input type="hidden" />
                    )}

                    <div className="row">
                        <div className="col-md-3 form-group">
                            <Form.Item label="Fecha / Tipo de Cambio">
                                <InputGroup compact>
                                    <Form.Item style={{ width: '65%' }}>
                                        {getFieldDecorator('fechaStr', {
                                            initialValue: moment(this.props.formValues.fechaStr, 'DD/MM/YYYY'),
                                            rules: [{
                                                type: 'object',
                                                required: true,
                                                message: 'Requerido'
                                            }],
                                        })(
                                            <DatePicker
                                                className="first-input"
                                                placeholder="Seleccione fecha"
                                                prefix={<Icon type="filter" style={{ color: 'rgba(0,0,0,.25)' }} />}
                                                format="DD/MM/YYYY"
                                                onChange={(moment, value) => {
                                                    this.props.onChange('fechaStr', value);
                                                    this.findDaysAndDates('fechaStr', value);
                                                }}

                                            />
                                        )}
                                    </Form.Item>
                                    <Form.Item style={{ width: '35%' }}>
                                        {getFieldDecorator('tipoCambio', {
                                            initialValue: parseFloat(this.props.formValues.tipoCambio).toFixed(3),
                                            rules: [{
                                                required: true,
                                                pattern: new RegExp(FORMAT_3DECIMALS),
                                                message: "Formato decimal incorrecto (0.000)"
                                            }]
                                        })(
                                            <Input
                                                className="text-right second-input"
                                                placeholder="Ingresar Tipo de Cambio"
                                                autoComplete="off"
                                                onBlur={(e) => this.handleCompleteDecimals("tipoCambio", e.target.value)}
                                            />
                                        )}
                                    </Form.Item>

                                </InputGroup>
                            </Form.Item>
                        </div>

                        <div className="col-md-3 form-group">
                            <Form.Item label="Serie / Documento">
                                <InputGroup compact>
                                    <Form.Item style={{ width: '40%' }}>
                                        {getFieldDecorator('serie', {
                                            initialValue: this.props.formValues.serie
                                        })(
                                            <Input
                                                placeholder="Serie"
                                                autoComplete="off"
                                                className="first-input"
                                                disabled={true}
                                            />
                                        )}
                                    </Form.Item>
                                    <Form.Item style={{ width: '60%' }}>
                                        {getFieldDecorator('documento', {
                                            initialValue: this.props.formValues.documento
                                        })(
                                            <Input
                                                placeholder="Documento"
                                                autoComplete="off"
                                                className="second-input"
                                                disabled={true}
                                            />
                                        )}
                                    </Form.Item>
                                </InputGroup>
                            </Form.Item>
                        </div>

                        <div className="col-md-3 form-group">
                            <Form.Item label="Dias / Fecha de Vencimiento">
                                <InputGroup compact>
                                    <Form.Item style={{ width: '35%' }}>
                                        {getFieldDecorator('diasVencimiento', {
                                            initialValue: this.props.formValues.diasVencimiento,
                                            rules: [{
                                                required: true,
                                                pattern: new RegExp(FORMAT_NUMBER),
                                                message: "Formato incorrecto"
                                            }]
                                        })(
                                            <Input
                                                style={{ textAlign: 'right' }}
                                                placeholder="Ingresar días de vencimiento"
                                                autoComplete="off"
                                                className="first-input"
                                                onBlur={(e) => this.findDaysAndDates('diasVencimiento', e.target.value)}
                                            />
                                        )}
                                    </Form.Item>
                                    <Form.Item style={{ width: '65%' }}>
                                        {getFieldDecorator('fechaVencimientoStr', {
                                            initialValue: moment(this.props.formValues.fechaVencimientoStr, 'DD/MM/YYYY'),
                                            rules: [{
                                                type: 'object',
                                                required: true,
                                                message: 'Requerido'
                                            }],
                                        })(
                                            <DatePicker
                                                placeholder="Seleccione fecha"
                                                prefix={<Icon type="filter" style={{ color: 'rgba(0,0,0,.25)' }} />}
                                                format="DD/MM/YYYY"
                                                className="second-input"
                                                onChange={(moment, value) => this.findDaysAndDates('fechaVencimientoStr', value)}
                                                disabledDate={d => !d || d.isBefore(this.props.form.getFieldValue('minFechaStr'))}
                                            />
                                        )}
                                    </Form.Item>
                                </InputGroup>
                            </Form.Item>
                        </div>

                        <div className="col-md-3 form-group">
                            <Form.Item label="Moneda">
                                {getFieldDecorator('idMoneda', {
                                    initialValue: this.props.formValues.idMoneda ?
                                        { key: this.props.formValues.idMoneda } : undefined,
                                    rules: [{
                                        required: true,
                                        message: 'Campo obligatorio.',
                                    }]
                                })(
                                    <Select showSearch labelInValue
                                        placeholder={"Seleccione Moneda"}
                                        optionFilterProp="children"
                                        onChange={(option) => this.props.onChange('idMoneda', option.key)}
                                    >
                                        {this.props.formValues.monedas.map(item => (
                                            <Option key={item.id} value={item.id}>{item.nombre}</Option>
                                        ))}
                                    </Select>
                                )}
                            </Form.Item>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-12 form-group">
                            <Form.Item label="Proveedor">
                                <InputGroup compact>
                                    <Form.Item style={{ width: "20%" }}>
                                        {getFieldDecorator("documentoProveedor", {
                                            initialValue: this.props.formValues.documentoProveedor,
                                            rules: [
                                                {
                                                    required: true,
                                                    message: "Campo obligatorio.",
                                                    whitespace: true,
                                                },
                                            ],
                                        })(
                                            <Search
                                                placeholder="Documento"
                                                className="first-input"
                                                autoComplete="off"
                                                loading={this.props.formValues.proveedorLoading}
                                                onSearch={(value) =>
                                                    this.props.onBuscarProveedor(value, this.props.form)
                                                }
                                                maxLength={20}
                                            />
                                        )}
                                    </Form.Item>
                                    <Form.Item style={{ width: "40%" }}>
                                        <InputGroup compact style={{ marginBottom: "1px" }}>
                                            {getFieldDecorator("idProveedor", {
                                                initialValue: this.props.formValues.idProveedor
                                                    ? { key: this.props.formValues.idProveedor }
                                                    : undefined,
                                                rules: [
                                                    {
                                                        required: true,
                                                        message: "Campo obligatorio.",
                                                    },
                                                ],
                                            })(
                                                <Select
                                                    showSearch
                                                    labelInValue
                                                    style={{
                                                        width: `calc(100% - 40px)`,
                                                        borderTopLeftRadius: "0px",
                                                    }}
                                                    placeholder={"Búsqueda de Proveedor"}
                                                    optionFilterProp="children"
                                                    showArrow={false}
                                                    onSearch={this.handleSearchAutocompleteProveedor}
                                                    onChange={this.handleChangeAutocompleteProveedor}
                                                >
                                                    {getFieldValue("proveedores").map((item) => (
                                                        <Option key={item.id} value={item.id} data={item}>
                                                            <Tag>{item.tipoDocumentoNombre}</Tag>
                                                            {`${item.nombre}`}
                                                        </Option>
                                                    ))}
                                                </Select>
                                            )}
                                            <Button
                                                className="btn-autocomplete"
                                                style={{ width: "40px", fontSize: "14px" }}
                                                icon={
                                                    this.props.form.getFieldValue("idProveedor")
                                                        ? "close"
                                                        : "search"
                                                }
                                                onClick={() => {
                                                    this.props.form.setFieldsValue(
                                                        {
                                                            idProveedor: undefined,
                                                            documentoProveedor: "",
                                                            idEstablecimientoProveedor: undefined,
                                                        },
                                                        () => {
                                                            this.props.onChange("direcciones-clear");
                                                        }
                                                    );
                                                }}
                                            />
                                        </InputGroup>
                                    </Form.Item>

                                    <Form.Item style={{ width: "40%" }}>
                                        {getFieldDecorator("idEstablecimientoProveedor", {
                                            initialValue: this.props.formValues
                                                .idEstablecimientoProveedor
                                                ? {
                                                    key: this.props.formValues
                                                        .idEstablecimientoProveedor,
                                                }
                                                : undefined,
                                            rules: [
                                                {
                                                    required: true,
                                                    message: "Campo obligatorio.",
                                                },
                                            ],
                                        })(
                                            <Select
                                                showSearch labelInValue
                                                placeholder={"Seleccione Direccion"}
                                                optionFilterProp="children"
                                            >
                                                {this.props.formValues.direcciones.map((item) => (
                                                    <Option key={item.id} value={item.id}>
                                                        {item.nombre + " - " + item.direccion}
                                                    </Option>
                                                ))}
                                            </Select>
                                        )}
                                    </Form.Item>
                                </InputGroup>
                            </Form.Item>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-3 form-group">
                            <Form.Item label="Tipo">
                                {getFieldDecorator('idTipo', {
                                    initialValue: this.props.formValues.idTipo ?
                                        { key: this.props.formValues.idTipo } : undefined
                                })(
                                    <Select showSearch labelInValue
                                        placeholder={"Seleccione Tipo"}
                                        onChange={(option) => this.props.onChange('idTipo', option.key)}
                                    >

                                        <Option key={1} value={1}>SERVICIO</Option>

                                    </Select>
                                )}
                            </Form.Item>
                        </div>

                        <div className="col-md-3 form-group">
                            <Form.Item label="Establecimiento">
                                {getFieldDecorator('idEstablecimiento', {
                                    initialValue: this.props.formValues.idEstablecimiento ?
                                        { key: this.props.formValues.idEstablecimiento } : undefined,
                                    rules: [{
                                        required: true,
                                        message: 'Campo obligatorio.',
                                    }]
                                })(
                                    <Select showSearch labelInValue
                                        placeholder={"Seleccione Establecimiento"}
                                        optionFilterProp="children"
                                        onChange={(option) => {
                                            this.props.onChange("idEstablecimiento", option.key)
                                        }}
                                    >
                                        {this.props.formValues.establecimientos.map(item => (
                                            <Option key={item.id} value={item.id}>{item.nombre}</Option>
                                        ))}
                                    </Select>
                                )}
                            </Form.Item>
                        </div>

                        <div className="col-md-3 form-group">
                            <Form.Item label="Proyecto">
                                {getFieldDecorator('idProyecto', {
                                    initialValue: this.props.formValues.idProyecto ?
                                        { key: this.props.formValues.idProyecto } : 0
                                })(
                                    <Select showSearch labelInValue
                                        placeholder={"Seleccione Proyecto"}
                                        optionFilterProp="children"
                                        onChange={(option) => this.props.onChange('idProyecto', option.key)}
                                    >
                                        <Option key={0} value={0}>
                                            <span style={{ color: "#bfbfbf" }}>Ninguno</span>
                                        </Option>
                                        {this.props.formValues.proyectos.map(item => (
                                            item.estado ?
                                                <Option key={item.id} value={item.id}>{item.nombre}</Option>
                                                : null
                                        ))}
                                    </Select>
                                )}
                            </Form.Item>
                        </div>

                        <div className="col-md-3 form-group">
                            <Form.Item label="Empleado">
                                {getFieldDecorator('idEmpleado', {
                                    initialValue: this.props.formValues.idEmpleado ?
                                        { key: this.props.formValues.idEmpleado } : undefined
                                })(
                                    <Select showSearch labelInValue
                                        placeholder={"Seleccione Empleado"}
                                        optionFilterProp="children"
                                        onChange={(option) => this.props.onChange('idEmpleado', option.key)}
                                    >
                                        {this.props.formValues.empleado.map(item => (
                                            <Option key={item.id} value={item.id}>{item.nombre}</Option>
                                        ))}
                                    </Select>
                                )}
                            </Form.Item>
                        </div>

                    </div>
                    <div className="row">
                        <div className="col-md-12 form-group">
                            <Form.Item label="Observación">
                                {getFieldDecorator('observacion', {
                                    initialValue: this.props.formValues.observacion
                                })(
                                    <Input
                                        placeholder="Ingresar Observación"
                                        autoComplete="off"
                                    />
                                )}
                            </Form.Item>
                        </div>
                    </div>


                    <div className="row">

                        <div className="col-md-9 form-group">
                            <Form.Item label="Condición de Pago">
                                {getFieldDecorator('condicion', {
                                    initialValue: this.props.formValues.condicion

                                })(
                                    <Input
                                        placeholder="Ingresar Condición"
                                        autoComplete="off"
                                    />
                                )}
                            </Form.Item>
                        </div>

                        <div className="col-md-3 form-group">
                            <Form.Item label="Plazo Entrega">
                                {getFieldDecorator('plazo', {
                                    initialValue: this.props.formValues.plazo

                                })(
                                    <Input
                                        placeholder="Ingresar Plazo Entrega"
                                        autoComplete="off"
                                    />
                                )}
                            </Form.Item>
                        </div>

                    </div>

                    <div className="row">
                        <div className="col-md-12 form-group">
                            <Tabs
                                activeKey={this.props.formValues.activeKey}
                                onChange={this.props.onChangeTab}
                                tabBarExtraContent={
                                    <div className="custom-options">
                                        <Button
                                            icon="import"
                                            type="primary"
                                            onClick={this.props.onImportarRequerimiento}
                                        >
                                            Importar Requerimiento
                                        </Button>
                                        <Button
                                            icon="plus"
                                            type="primary"
                                            onClick={this.props.onAgregarDetalle}
                                        >
                                            Agregar
                                        </Button>
                                    </div>
                                }
                            >
                                <TabPane tab="Detalle de Servicios" key="1">
                                    <DetalleServicioModal
                                        dataSource={this.props.formValues.listaComprobanteDetalle}
                                        onRemove={this.handleRemoverProducto}
                                        onCalculateDetail={this.handleCalculateDetail}
                                        onGetFieldDecorator={getFieldDecorator}
                                        onGetFieldValue={getFieldValue}
                                        onSetFieldsValue={setFieldsValue}
                                        onChangeNameProduct={this.handleChangeNameProduct}
                                        tipoAfectacion={this.props.formValues.tipoAfectacion}

                                    />
                                </TabPane>
                                <TabPane tab="Detalle de Referencias" key="2">
                                    <DetalleReferenciaModal
                                        dataSource={this.props.formValues.listaComprobanteReferencia}
                                        tiposComprobante={this.props.formValues.tiposComprobante}
                                        onRemove={this.props.onRemoverReferencia}
                                        onGetFieldDecorator={getFieldDecorator}
                                    />
                                </TabPane>
                            </Tabs>
                        </div>
                    </div>
                    <TotalDetalle
                        formValues={this.props.formValues}
                        onGetFieldDecorator={getFieldDecorator}
                        onGetFieldValue={getFieldValue}
                    />
                </Form>
            </Modal>
        )
    }
}

export default Form.create()(FormModal)